import React, { useState, useRef , forwardRef, useImperativeHandle } from "react";
import { Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import {AgGridColumn, AgGridReact} from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import './styles.css'
// components

const useStyles = makeStyles(theme => ({
  tableOverflow: {
    overflow: 'auto'
  },  
  success: {
    height:25,
    marginTop:-2,
    backgroundColor: theme.palette.success.main,
    color: '#fff',
  },
  warning: {
    height:25,
    marginTop:-2,
    backgroundColor: theme.palette.warning.main,
    color: '#fff',
  },
  secondary: {
    height:25,
    marginTop:-2,
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
  }
}))

const states = {
  sent: "success",
  warning: "warning",
  secondary: "secondary",
};

export default forwardRef ( function Tables(props,ref) {
  
  const classes = useStyles();
  const gridRef = useRef(null);

  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  useImperativeHandle(ref, () => ({
    onBtnExport() {
        if(gridRef.current.api.getSelectedNodes().length)
            gridApi.exportDataAsCsv({onlySelected: true});
        else 
            gridApi.exportDataAsCsv();
    }
  }));

  const rowStyle = { background: 'white' };

  return (
    <div className="ag-theme-material" style={{height: 620, width: '100%'}} id="#grid-theme-wrapper">
        <AgGridReact
            ref={gridRef}
            rowData={props.tableData}
            suppressExcelExport={true}
            rowSelection="multiple"
            defaultColDef={{
                filter: 'agTextColumnFilter',
                resizable: true,
                sortable:true,
                headerComponentParams: {
                  template:
                    '<div class="ag-cell-label-container" role="presentation">' +
                    '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                    '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                    '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
                    '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
                    '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
                    '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
                    '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
                    '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                    '  </div>' +
                    '</div>',
                },              
            }}            
            onGridReady={onGridReady}
            pagination={true}
            paginationPageSize={10}
            rowStyle={rowStyle}
            suppressDragLeaveHidesColumns={true}
        >
            <AgGridColumn headerName="Dispute Date" field="Dispute date" width={150} />
            <AgGridColumn headerName="Account Name" field="Account Name" width={150} />
            <AgGridColumn headerName="Dispute ID" field="Dispute ID" width={150} />
            <AgGridColumn headerName="Invoice#" field="Invoice" width={150} />
            <AgGridColumn headerName="PO" field="PO" width={150} />
            <AgGridColumn headerName="Dispute Status" field="Dispute status" width={150} />            
            <AgGridColumn headerName="Total Disputed Amount" field="Total disputed amount" width={150} />
            <AgGridColumn headerName="Approved Amount" field="Approved Amount" width={150} />
            <AgGridColumn headerName="Approved (Yes/No)" field="Approved (Yes/No)" width={150} />
			<AgGridColumn headerName="Case ID (1st Attempt)" field="Case ID (1st Attempt)" width={150} />
            <AgGridColumn headerName="Date (Case 1)" field="Date (Case 1)" width={150} />
            <AgGridColumn headerName="Approved (Yes/No)2" field="Approved (Yes/No)2" width={150} />
            <AgGridColumn headerName="Amount" field="Amount" width={150} />                                    
			<AgGridColumn headerName="Case ID (2nd Attempt)" field="Case ID (2nd Attempt)" width={150} />   
            <AgGridColumn headerName="Date (Case 2)" field="Date (Case 2)" width={150} />   
            <AgGridColumn headerName="Approved (Yes/No)3" field="Approved (Yes/No)3" width={150} />   
            <AgGridColumn headerName="Amount4" field="Amount4" width={150} />   
            <AgGridColumn headerName="Resolved Amount" field="Resolved Amount" width={150} />   
            <AgGridColumn headerName="Main Status" field="Main Status" width={150} />                                                   
                                                                                              
        </AgGridReact>
    </div>
  );
})

function cellStyle(params) {
  var color;
  // if(params.column["colId"]=="Rep OOS" || params.column["colId"]=="Rep OOS - % of Total"){
  //   if(params.value.charAt(0) === "-")
  //     color = '#d8e9d2'
  //   else color = '#e6b7af'
  // } else {
  //   if(params.value.charAt(0) === "-")
  //     color = '#e6b7af'
  //   else if(params.value === "")
  //     color = null
  //   else color = '#d8e9d2'
  // }
  return { 
    // backgroundColor: color,
    borderBottom: '1px solid rgba(178,178,178,0.25)'
  };
}

const decimalComparator = (valueA, valueB) => parseFloat(valueA) - parseFloat(valueB);

const decimalComparatorWithDollar = (valueA, valueB) => parseFloat(valueA.includes("-") ? valueA.replace("$", "") : valueA.slice(1)) - parseFloat(valueB.includes("-") ? valueB.replace("$", "") : valueB.slice(1));

const integerComparatorWithComma = (valueA, valueB) => parseInt(valueA.replace(",","")) - parseInt(valueB.replace(",",""));
